// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: peer/peer.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Value } from "../google/protobuf/struct";
import { Timestamp } from "../google/protobuf/timestamp";
import { Producer } from "../producer/producer";
import { ProducerLabel, producerLabelFromJSON, producerLabelToJSON } from "../producer/producer_label";
import { PeerGroup, peerGroupFromJSON, peerGroupToJSON } from "./peer_group";
import { PeerRole, peerRoleFromJSON, peerRoleToJSON } from "./peer_role";

export const protobufPackage = "peer";

export interface Peer {
  id: string;
  channelIds: string[];
  producers: Producer[];
  uid: string;
  appId: string;
  appData: { [key: string]: any | undefined };
  role: PeerRole;
  loginDate: Date | undefined;
  groups: PeerGroup[];
  producePermissions: ProducerLabel[];
}

export interface Peer_AppDataEntry {
  key: string;
  value: any | undefined;
}

function createBasePeer(): Peer {
  return {
    id: "",
    channelIds: [],
    producers: [],
    uid: "",
    appId: "",
    appData: {},
    role: 0,
    loginDate: undefined,
    groups: [],
    producePermissions: [],
  };
}

export const Peer: MessageFns<Peer> = {
  encode(message: Peer, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    for (const v of message.channelIds) {
      writer.uint32(18).string(v!);
    }
    for (const v of message.producers) {
      Producer.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.uid !== "") {
      writer.uint32(50).string(message.uid);
    }
    if (message.appId !== "") {
      writer.uint32(58).string(message.appId);
    }
    Object.entries(message.appData).forEach(([key, value]) => {
      if (value !== undefined) {
        Peer_AppDataEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).join();
      }
    });
    if (message.role !== 0) {
      writer.uint32(72).int32(message.role);
    }
    if (message.loginDate !== undefined) {
      Timestamp.encode(toTimestamp(message.loginDate), writer.uint32(82).fork()).join();
    }
    writer.uint32(90).fork();
    for (const v of message.groups) {
      writer.int32(v);
    }
    writer.join();
    writer.uint32(98).fork();
    for (const v of message.producePermissions) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Peer {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeer();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.channelIds.push(reader.string());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.producers.push(Producer.decode(reader, reader.uint32()));
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.uid = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.appId = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          const entry8 = Peer_AppDataEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.appData[entry8.key] = entry8.value;
          }
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.role = reader.int32() as any;
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.loginDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 11: {
          if (tag === 88) {
            message.groups.push(reader.int32() as any);

            continue;
          }

          if (tag === 90) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.groups.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 12: {
          if (tag === 96) {
            message.producePermissions.push(reader.int32() as any);

            continue;
          }

          if (tag === 98) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.producePermissions.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Peer {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      channelIds: globalThis.Array.isArray(object?.channelIds)
        ? object.channelIds.map((e: any) => globalThis.String(e))
        : [],
      producers: globalThis.Array.isArray(object?.producers)
        ? object.producers.map((e: any) => Producer.fromJSON(e))
        : [],
      uid: isSet(object.uid) ? globalThis.String(object.uid) : "",
      appId: isSet(object.appId) ? globalThis.String(object.appId) : "",
      appData: isObject(object.appData)
        ? Object.entries(object.appData).reduce<{ [key: string]: any | undefined }>((acc, [key, value]) => {
          acc[key] = value as any | undefined;
          return acc;
        }, {})
        : {},
      role: isSet(object.role) ? peerRoleFromJSON(object.role) : 0,
      loginDate: isSet(object.loginDate) ? fromJsonTimestamp(object.loginDate) : undefined,
      groups: globalThis.Array.isArray(object?.groups) ? object.groups.map((e: any) => peerGroupFromJSON(e)) : [],
      producePermissions: globalThis.Array.isArray(object?.producePermissions)
        ? object.producePermissions.map((e: any) => producerLabelFromJSON(e))
        : [],
    };
  },

  toJSON(message: Peer): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.channelIds?.length) {
      obj.channelIds = message.channelIds;
    }
    if (message.producers?.length) {
      obj.producers = message.producers.map((e) => Producer.toJSON(e));
    }
    if (message.uid !== "") {
      obj.uid = message.uid;
    }
    if (message.appId !== "") {
      obj.appId = message.appId;
    }
    if (message.appData) {
      const entries = Object.entries(message.appData);
      if (entries.length > 0) {
        obj.appData = {};
        entries.forEach(([k, v]) => {
          obj.appData[k] = v;
        });
      }
    }
    if (message.role !== 0) {
      obj.role = peerRoleToJSON(message.role);
    }
    if (message.loginDate !== undefined) {
      obj.loginDate = message.loginDate.toISOString();
    }
    if (message.groups?.length) {
      obj.groups = message.groups.map((e) => peerGroupToJSON(e));
    }
    if (message.producePermissions?.length) {
      obj.producePermissions = message.producePermissions.map((e) => producerLabelToJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Peer>, I>>(base?: I): Peer {
    return Peer.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Peer>, I>>(object: I): Peer {
    const message = createBasePeer();
    message.id = object.id ?? "";
    message.channelIds = object.channelIds?.map((e) => e) || [];
    message.producers = object.producers?.map((e) => Producer.fromPartial(e)) || [];
    message.uid = object.uid ?? "";
    message.appId = object.appId ?? "";
    message.appData = Object.entries(object.appData ?? {}).reduce<{ [key: string]: any | undefined }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );
    message.role = object.role ?? 0;
    message.loginDate = object.loginDate ?? undefined;
    message.groups = object.groups?.map((e) => e) || [];
    message.producePermissions = object.producePermissions?.map((e) => e) || [];
    return message;
  },
};

function createBasePeer_AppDataEntry(): Peer_AppDataEntry {
  return { key: "", value: undefined };
}

export const Peer_AppDataEntry: MessageFns<Peer_AppDataEntry> = {
  encode(message: Peer_AppDataEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      Value.encode(Value.wrap(message.value), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Peer_AppDataEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePeer_AppDataEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Peer_AppDataEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object?.value) ? object.value : undefined,
    };
  },

  toJSON(message: Peer_AppDataEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = message.value;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Peer_AppDataEntry>, I>>(base?: I): Peer_AppDataEntry {
    return Peer_AppDataEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Peer_AppDataEntry>, I>>(object: I): Peer_AppDataEntry {
    const message = createBasePeer_AppDataEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
